export default __webpack_public_path__ + "bml-qianfanf6a53b.png";